<template>
  <a-layout id="service-big-topology">
    <a-layout-header style="background: #ffffff">
      <a-button
        @click="$router.push({
          name: 'ServiceDashboardDetail',
          params: {
            id
          }
        })"
        type="link"
      >
        <a-icon type="arrow-left"></a-icon>
        <span>退出全屏</span>
      </a-button>
      <a-space style="float: right">
        <reload-button @click="fetch"></reload-button>
        <a
          @click="generate"
          style="color: #333; font-size: 16px; user-select: none"
        >
          <a-icon type="sync"></a-icon>
          <span style="font-size: 12px; color: rgba(0,0,0,0.5); margin-left: 4px">生成</span>
        </a>
      </a-space>
    </a-layout-header>
    <a-layout-content style="min-height: calc(100vh - 226px); padding: 38px 24px 24px; height: calc(100vh - 226px); background: #fff; overflow: hidden; display: flex;">
      <status-question-icon
        :is-service-topology="true"
        :is-in-table="false"
        style="position: absolute; left: 30px; top: 76px"
      ></status-question-icon>
      <div id="big-topology" style="width: 100%; flex: 1;"></div>
    </a-layout-content>

    <network-device-drawer ref="networkDeviceDrawer"></network-device-drawer>
    <storage-drawer ref="storageDrawer"></storage-drawer>
    <server-drawer ref="serverDrawer"></server-drawer>
    <os-drawer ref="osDrawer"></os-drawer>
    <middleware-drawer ref="middlewareDrawer"></middleware-drawer>
    <database-drawer ref="databaseDrawer"></database-drawer>
    <application-drawer ref="applicationDrawer"></application-drawer>
    <site-drawer ref="siteDrawer"></site-drawer>
  </a-layout>
</template>

<script>
import { Graph } from '@antv/x6'
import { generateServiceTopology, getService } from '@/api/service'
import ReloadButton from '@/components/button/ReloadButton'
import ApplicationDrawer from '@/components/drawer/ApplicationDrawer'
import DatabaseDrawer from '@/components/drawer/DatabaseDrawer'
import MiddlewareDrawer from '@/components/drawer/MiddlewareDrawer'
import NetworkDeviceDrawer from '@/components/drawer/NetworkDeviceDrawer'
import OSDrawer from '@/components/drawer/OSDrawer'
import ServerDrawer from '@/components/drawer/ServerDrawer'
import SiteDrawer from '@/components/drawer/SiteDrawer'
import StorageDrawer from '@/components/drawer/StorageDrawer'
import StatusQuestionIcon from '@/components/icon/StatusQuestionIcon'

let graph = null

export default {
  name: 'ServiceDashboardTopologyDetail',
  components: {
    ApplicationDrawer,
    DatabaseDrawer,
    MiddlewareDrawer,
    NetworkDeviceDrawer,
    'os-drawer': OSDrawer,
    ReloadButton,
    ServerDrawer,
    SiteDrawer,
    StorageDrawer,
    StatusQuestionIcon
  },
  data () {
    return {
      cells: [],
      id: this.$route.params.id
    }
  },
  mounted () {
    this.fetch()
    this.initGraph()
    graph.fromJSON({ cells: this.formatterData(this.cells) })
    graph.scaleContentToFit({ maxScale: 1.5, minScale: 0.5 })
    graph.centerContent()
  },
  methods: {
    fetch () {
      getService(this.id)
        .then(res => {
          this.cells = res.data.topology
        })
    },
    initGraph () {
      const container = document.getElementById('big-topology')
      graph = new Graph({
        container,
        grid: false,
        autoResize: false,
        scroller: false,
        keyboard: false,
        panning: true,
        interacting: false,
        connecting: {
          validateMagnet ({ e, magnet, view, cell }) {
            return false
          }
        }
      })
      graph.on('node:collapse', ({ e, node, view }) => {
        node.toggleCollapse()
        const collapsed = node.collapsed
        const cells = node.getDescendants()
        cells.forEach(cell => {
          if (collapsed) {
            cell.hide()
          } else {
            cell.show()
          }
        })
      })

      graph.on('node:click', ({ node }) => {
        if (node.view === 'vue-shape-view') {
          const data = node.data
          if (data) {
            switch (data.sourceType) {
              case 'network_device':
                this.$refs.networkDeviceDrawer.show(data.sourceId)
                break
              case 'storage':
                this.$refs.storageDrawer.show(data.sourceId)
                break
              case 'server':
                this.$refs.serverDrawer.show(data.sourceId)
                break
              case 'os':
                this.$refs.osDrawer.show(data.sourceId)
                break
              case 'middleware':
                this.$refs.middlewareDrawer.show(data.sourceId)
                break
              case 'database':
                this.$refs.databaseDrawer.show(data.sourceId)
                break
              case 'application':
                this.$refs.applicationDrawer.show(data.sourceId)
                break
              case 'site':
                this.$refs.siteDrawer.show(data.sourceId)
                break
            }
          }
        }
      })
    },
    formatterData (v) {
      v.forEach(item => {
        if (item.shape === 'edge') {
          item.attrs.line.stroke = '#999'
          item.attrs.line.strokeWidth = 0.5
          item.attrs.line.targetMarker = null
        }
        if (item.shape === 'group') {
          item.attrs.button.fill = '#1890ff90'
        }
        if (item.shape === 'vue-shape') {
          item.size = { height: 48, width: 48 }
          if (Array.isArray(item.ports)) {
            const ports = item.ports
            item.ports = {
              groups: {
                default: {
                  markup: [
                    {
                      tagName: 'rect',
                      selector: 'rect'
                    }
                  ],
                  attrs: {
                    rect: {
                      magnet: true,
                      stroke: '#31d0c6',
                      fill: 'rgba(255,255,255,0)',
                      strokeWidth: 0,
                      width: 48,
                      height: 48,
                      y: -24
                    }
                  }
                }
              },
              items: []
            }

            ports.forEach(port => {
              port.group = 'default'
            })
            item.ports.items = ports
          }
        }
      })
      return v
    },
    generate () {
      generateServiceTopology(this.id).then(res => {
        this.$message.success(res.message)
      })
    }
  },
  watch: {
    cells (v) {
      graph.fromJSON({ cells: this.formatterData(v) })
      graph.scaleContentToFit({ maxScale: 1.5, minScale: 0.5 })
      graph.centerContent()
    }
  }
}
</script>

<style lang="less">
#service-big-topology {
  height: calc(100vh - 162px);
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: rgba(0, 0, 0, 0.08) 0px 0px 8px;

  .ant-layout-header {
    padding: 0 12px;
    border-bottom: 1px solid rgba(0,0,0,0.1);
  }
  #big-topology {
    min-height: calc(100vh - 280px);

    .x6-port-default {
      rect {
        cursor: pointer;
      }
    }
  }
}
</style>
